export default "__VITE_ASSET__afd6a2f1__"